import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BaseComponent } from '../../../core/components/base.component';
import { AppConfigService } from '../../../core/services/app-config.service';

@Component({
    selector: 'app-site-template',
    templateUrl: './site-template.component.html',
    styleUrls: ['./site-template.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SiteTemplateComponent extends BaseComponent implements OnInit {
  protected isTest: boolean = false;

  constructor(private readonly appConfigService: AppConfigService) {
    super();
  }

  ngOnInit(): void {
    this.isTest = this.appConfigService.getConfig().isTest;
  }
}
